/**
 * 브라우저에서 텍스트 콘텐츠를 파일로 다운로드 (KBNL-27).
 *
 * Blob → URL.createObjectURL → 임시 <a> click → revoke 패턴.
 * Windows/macOS/Linux 어디서든 동작.
 */

/** 파일명에서 OS 가 거부할 수 있는 문자 치환. trim 포함. */
export function sanitizeFilename(name) {
  return String(name || '').replace(/[\\/:*?"<>|]/g, '_').trim()
}

/**
 * 텍스트를 .txt/.yaml/.sql 등 임의 파일로 다운로드.
 *
 * @param {string} filename — 표시될 파일명 (확장자 포함, 빈/이상 문자 자동 정리)
 * @param {string} text     — 파일 내용
 * @param {string} mime     — MIME (기본 'text/plain', YAML 은 'text/yaml')
 */
export function downloadText(filename, text, mime = 'text/plain') {
  const safe = sanitizeFilename(filename) || 'download.txt'
  const blob = new Blob([text ?? ''], { type: `${mime};charset=utf-8` })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = safe
  document.body.appendChild(a)
  a.click()
  a.remove()
  // revoke 는 click 직후 곧바로 하면 일부 브라우저에서 다운로드 실패 — 약간 지연
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}

/** 확장자 보장: name 끝에 .{ext} 가 없으면 붙임. ext 는 점 없이 ('yaml', 'sql'). */
export function ensureExtension(name, ext) {
  const safe = sanitizeFilename(name) || 'download'
  const lower = safe.toLowerCase()
  const dotExt = '.' + ext.replace(/^\./, '').toLowerCase()
  return lower.endsWith(dotExt) ? safe : safe + dotExt
}
